import type { IconType } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Content } from "./Content";

export interface UserActionProps {
  action: {
    tooltip?: string;
    icon: IconType;
    onClick: (item: any) => void;
  };
  item: any;
}

export const UserAction = ({ item, action }: UserActionProps) => {
  const { tooltip, ...rest } = action;

  if (tooltip) {
    return (
      <TippyV2 content={tooltip}>
        <Content item={item} {...rest} />
      </TippyV2>
    );
  }

  return <Content item={item} {...rest} />;
};
